import Content from '../content-interface';
import ReadjustmentRuleHistory from './readjustment-rules-history.entity';

export default class ReadjustmentHistory implements Content {
  version: number;

  percentage: number;

  rules: ReadjustmentRuleHistory[]

  constructor(obj: any = {}) {
    this.version = obj.version || '';
    this.percentage = obj.percentage || '';
    this.rules = ReadjustmentRuleHistory.ofList(obj.rules) || [];
  }

  public static of(obj: any = {}): ReadjustmentHistory {
    return new ReadjustmentHistory(obj);
  }

  public static ofList(obj: any[]): ReadjustmentHistory[] {
    return obj.map(this.of)
  }
}
